module.exports = __webpack_public_path__ + "img/stress.edb969d2.svg";